<!-- navItem „Basisdaten“ — Vertrag, Provisionstyp, Ereignis und Zeitscheibe. -->
<div class="cp-provision-contract-base-data">

    <cp-provision-object-data
            objectType="cp.ProvisionContract"
            [objectId]="provisionContractId"
            widgetAlias="cp.provisionContract.baseData"
            widgetTitle="Basisdaten"
            [fields]="fields"
            [columns]="columns"
            emptyText="Keine Provisionszeile ausgewählt.">
    </cp-provision-object-data>

</div>
